import getApiClient from 'src/utils/getApiClient'
import type { ApiTownParamsGet, ApiTownResponseGet } from 'src/components/pages/memorial/MemoryBoardPage/api/apiTownList.type'

const apiClient = getApiClient()

export default {
  get(params: ApiTownParamsGet = {}) {
    return apiClient.get<ApiTownResponseGet>('/api/town/memorial/', { params })
  },
}
